import { BaseService } from './base';
import { PaymentModel } from '../models/paymentModel';

export class PaymentModelService extends BaseService<PaymentModel> {
  override model = PaymentModel;
  override modelName = 'paymentModel';
  override modelLabel = 'Payment Model';
}
